import React from 'react';
import { Card } from '../../components/ui';

export default function StarterList({ starters, limit, onPick }) {
  const shown = (starters || []).slice(0, limit);
  if (!shown.length) return null;
  return (
    <div className="flex flex-col gap-3">
      {shown.map((s) => (
        <Card
          key={s.id}
          as="button"
          type="button"
          variant="interactive"
          onClick={() => onPick(s)}
          className="p-4 text-left focus-ring"
        >
          <span className="block font-display font-semibold text-ink">{s.title}</span>
          {s.youAdd && <span className="block text-sm text-pencil">You add: {s.youAdd}</span>}
        </Card>
      ))}
    </div>
  );
}
